import LocalizedStrings from "react-localization";

const defaultEn: Record<string, string> = {
    // General
    appName: "Tax NBB",
    create: "Create",
    add: "Add",
    update: "Update",
    delete: "Delete",
    cancel: "Cancel",
    edit: "Edit",
    save: "Save",
    close: "Close",
    download: "Download",
    notFound: "Not Found",
    yes: "Yes",
    user: "User",
    userName: "Username",
    psw: "Password",
    loading: "Loading",
    downloading: "Downloading",
    alert: "Alert",
    success: "Success",

    // Errors
    invalidName: "Invalid Name",
    invalidYear: "Invalid Year",
    unauthorizedError: "Unauthorized. Your session likely expired.",
    unreachableError: "Can not reach server. Please contact the system administator.",
    forbiddenError: "Forbidden. Your permissions are too low.",
    unresponsiveError: "Server not responding. Please contact the system administator.",
    tooManyRequestError: "You have sent too many requests. Please try again later",
    pleaseWait: "Please wait. Uploaded data is being processed.",
    invalidValue: "Can not set cell to invalid value.",
    invalidDate: "Invalid date. Must be formatted YYYYMMDD (no dashes).",
    invalidPsw: "Invalid password.",
    pswMismatch: "Mismatch",
    invalidUsername: "Invalid username",
    invalidEmail: "Invalid email",
    sessionExpired: "Session expired after 30 minutes of inactivity.",

    // Login page
    login: "Login",
    adLogin: "ADLogin",
    welcome: "Welcome to Tax NBB",
    loginSuccess: "Login Successfull",
    logoutSuccess: "Logout Successfull",

    // Top Bar
    profile: "Profile",
    settings: "Settings",
    admin: "Admin",
    userManagement: "User Management",
    logout: "Logout",
    home: "Home",

    // Profile
    language: "Language",
    english: "English",
    japanese: "Japanese",
    changePsw: "Change Password",
    newPsw: "New Password",
    retypePsw: "Retype New Password",

    // User Management
    addUser: "Add User",
    editUser: "Edit User",
    deleteUserMessage: "Are you sure you want to delete user?",
    permissions: "Permissions",
    email: "Email",
    resetPsw: "Reset Password",
    pswChanged: "Password is changed and please do the login again.",
    pswChangedOnly: "Password is changed.",
    createUser: "User has been successfully created.",
    updateUser: "User has been successfully updated.",
    deleteUser: "User has been successfully deleted.",

    // Audit Logs
    auditLogs: "Audit Logs",
    message: "Message",
    date: "Date",
    all: "All",
    table: "Table",
    file: "File",
    selectClientAlert: "Please select a client before proceed with log.",
    filteredLog: "Log has been filtered.",

    // Workbook List
    primaryWorkbook: "Primary Workbook",
    secondaryWorkbook: "Secondary Workbook",
    confirmLock: "Are you sure you want to lock workbook?",
    confirmDelete: "Are you sure you want to delete workbook?",
    name: "Name",
    year: "Year",
    lastModified: "Last Modified",
    isPrimary: "Is Primary",
    workbookYear: "Workbook Year",
    workbookName: "Workbook Name",
    newWorkbook: "New Workbook",
    editWorkbook: "Edit Workbook",
    manageFiles: "Manage Files",
    viewTables: "View Tables",
    downloadAll: "Download All",
    downloadOnlyNew: "Download Only New Files",
    editInfo: "Edit Info",
    lock: "Lock",
    unlock: "Unlock",
    createWorkbook: "Workbook has been successfully created.",
    updateWorkbook: "Workbook has been successfully updated.",
    deleteWorkbook: "Workbook has been successfully deleted.",
    downloadStart: "Download will start.",

    // General Lists
    page: "Page",
    of: "of",
    nothingAddedYet: "Nothing added yet.",

    // File Uploading
    fileName: "File Name",
    status: "Status",
    upload: "Upload",
    requiredFiles: "Required Files",
    uploadingFiles: "Uploading Files",
    pending: "Pending",
    uploading: "Uploading",
    done: "Done",
    failed: "Not Eligible for Upload",
    processing: "Processing",
    prepareZip: "Prepare Zip",
    processXlsx: "Process XLSX Files",
    processCsv: "Process CSV Files",
    processPdf: "Process PDF Files",
    fileNotFound: "File Not Found",

    // Table
    numberChanges: "Changes",
    nothingToDisplay: "Nothing to Display",
    pleaseUpload: "Please upload required .csv files.",
    uploaded: "Uploaded",
    missing: "Missing",

    // Admin
    users: "Users",
    databases: "Databases",
    clients: "Clients",
    isStaff: "Staff",
    isSuperuser: "Superuser",
    isSupport: "Support",
    editPermission: "Edit Permission",
    addDatabase: "Add Database",
    databaseName: "Database Name",
    dbNameError: "Must be 3-8 characters a-z.",
    createDbSuccess: "Database has been successfully created.",

    // New
    error: "Error",
    userNotExist: "User does not exist",
    wrongUploadOrder: "Please follow the upload order.",
    uploadExcel: 'Upload all "還付明細.xlsx", "基礎情報.xlsx", "PY地方税額.xlsx"',
    uploadCSV: "Upload CSV files",
    uploadPDF: "Upload PDF files",
    noClientsError: "Error Your account doesn't link to any clients",

    // Backend Message
    actionRoleSuperuser: "Required superuser role.",
    invalidData: "Data not valid.",
    userNotFound: "User not found.",
    invalidToken: "Invalid token",
    existDatabase: "Database Already Exists",
    authorizationNotFound: "No Authorization header was found",
    invalidCredential: "Invalid username/password.",
    deactiveUser: "User is deactive",
    unauthorizedEscalation: "Unauthorized privilege escalation.",
    noFileUploaded: "No File Uploaded",
    workbookLocked: "Workbook Locked",
    unsupportedFileType: "Unsupported File Type",
    missingRequirments: "Missing Requirments",
    missingDbId: "Missing db or workbook_id",
    fileProcessing: "The file is processing",
    applicationClear: "Application cleared.",

    // Opt api
    optAD: "OPT AD",
    optApiError: "OPT error",
    optApiSuccess: "OPT success"
};
const defaultJa: Record<string, string> = {
    // General
    appName: "Tax NBB",
    create: "作成",
    add: "追加",
    update: "更新",
    delete: "削除",
    cancel: "キャンセル",
    edit: "編集",
    save: "保存",
    close: "閉じる",
    download: "ダウンロード",
    notFound: "見つかりません",
    yes: "はい",
    user: "ユーザー",
    userName: "ユーザー名",
    psw: "パスワード",
    loading: "ロード中",
    downloading: "ダウンロード中",
    alert: "注意",
    success: "成功",

    // Errors
    invalidName: "無効な「名前」です。",
    invalidYear: "無効な「年」です。",
    unauthorizedError: "アクセス権限がありません。セッションが切断されました。",
    unreachableError: "サーバーに接続できません。システム管理者にお問い合わせください。",
    forbiddenError: "Forbiddenエラー：あなたはサイトを閲覧する許可がありません。",
    unresponsiveError: "サーバーが応答しません。システム管理者にお問い合わせください。",
    tooManyRequestError: "リクエスト回数が多すぎます。しばらく時間を開けてからご利用ください。",
    pleaseWait: "アップロード処理中です。しばらくお待ちください。",
    invalidValue: "無効な値が入力されています。",
    invalidDate: "無効な日付が入力されています。YYYYMMDD形式で入力してください。",
    invalidPsw: "無効なパスワードです。",
    pswMismatch: "入力されたパスワードが一致しません。",
    invalidUsername: "Invalid username",
    invalidEmail: "メールアドレスの形式が間違っています。",
    sessionExpired: "30分間操作がなかったため、ログアウトしました。",

    // Login page
    login: "ログイン",
    adLogin: "ADログイン",
    welcome: "ようこそ Tax NBB へ",
    loginSuccess: "ログインしました。",
    logoutSuccess: "ログアウトしました。",

    // Top Bar
    profile: "プロフィール",
    settings: "設定",
    admin: "アドミン",
    userManagement: "ユーザー管理",
    logout: "ログアウト",
    home: "Home",

    // Profile
    language: "言語",
    english: "英語",
    japanese: "日本語",
    changePsw: "パスワードの変更",
    newPsw: "新しいパスワード",
    retypePsw: "再度新しいパスワードを入力",

    // User Management
    addUser: "ユーザーの追加",
    editUser: "ユーザーの編集",
    deleteUserMessage: "このユーザーを削除しますがよろしいですか？",
    permissions: "許可/権限",
    email: "ユーザ名 (Eメール)",
    resetPsw: "パスワードリセット",
    pswChanged: "パスワードが変更されました。もう一度ログインしてください。",
    pswChangedOnly: "パスワードが変更されました。",
    createUser: "ユーザーが作成されました。",
    updateUser: "ユーザーが更新されました。",
    deleteUser: "ユーザーが削除されました。",

    // Audit Logs
    auditLogs: "監査ログ",
    message: "メッセージ",
    date: "日付",
    all: "すべて",
    table: "テーブル",
    file: "ファイル",
    selectClientAlert: "ログを確認できません。クライアントを選択してください。",
    filteredLog: "ログをフィルタリングしました。",

    // Workbook List
    primaryWorkbook: "プライマリワークブック",
    secondaryWorkbook: "セカンダリワークブック",
    confirmLock: "このワークブックをロックしますがよろしいですか？",
    confirmDelete: "このワークブックを削除しますがよろしいですか？",
    name: "名前",
    year: "年度",
    lastModified: "最終更新",
    isPrimary: "プライマリー",
    workbookYear: "年度 (西暦)",
    workbookName: "ワークブック名",
    newWorkbook: "新しいワークブック",
    editWorkbook: "ワークブックの編集",
    manageFiles: "ファイルの管理",
    viewTables: "テーブルの閲覧",
    downloadAll: "一括ダウンロード",
    downloadOnlyNew: "新しいファイルのみダウンロード",
    editInfo: "情報の編集",
    lock: "ロック",
    unlock: "アンロック",
    createWorkbook: "ワークブックが作成されました。",
    updateWorkbook: "ワークブックが更新されました。",
    deleteWorkbook: "ワークブックが削除されました。",
    downloadStart: "ダウンロードを開始しました。",

    // General Lists
    page: "ページ",
    of: "/",
    nothingAddedYet: "まだ追加されていません。",

    // File Uploading
    fileName: "ファイル名",
    status: "ステータス",
    upload: "アップロード",
    requiredFiles: "アップロード対象ファイル",
    uploadingFiles: "アップロードファイル",
    pending: "保留",
    uploading: "アップロード中",
    done: "完了",
    failed: "アップロード対象外",
    processing: "処理中",
    prepareZip: "zipファイル作成",
    processXlsx: "Process XLSX Files",
    processCsv: "Process CSV Files",
    processPdf: "Process PDF Files",
    fileNotFound: "File Not Found",

    // Table
    numberChanges: "個所の値が変更されています",
    nothingToDisplay: "表示するデータがありません。",
    pleaseUpload: "必要なCSVファイルをアップロードしてください。",
    uploaded: "アップロード完了",
    missing: "未アップロード",

    // Admin
    users: "ユーザー",
    databases: "データベース",
    clients: "クライアント",
    isStaff: "スタッフ",
    isSuperuser: "スーパーユーザー",
    isSupport: "サポート",
    editPermission: "許可/権限の編集",
    addDatabase: "データベースの追加",
    databaseName: "データベース名",
    dbNameError: "aからzの文字を使い、最低3文字、最高8文字内で入力してください。",
    createDbSuccess: "データベースが作成されました。",

    // New
    error: "エラー",
    userNotExist: "このアカウントは存在しません",
    wrongUploadOrder: "指定されたファイルのアップロードに失敗しました。",
    uploadExcel: "「還付明細.xlsx」「基礎情報.xlsx」「PY地方税額.xlsx」を全部アップロードしてください。",
    uploadCSV: "CSVファイルをアップロードしてください。",
    uploadPDF: "PDFファイルをアップロードしてください。",
    noClientsError: "このアカウントはどのクライアントにもリンクしていません",

    // Backend Message
    actionRoleSuperuser: "権限がありません。スーパーユーザーでログインしてください。",
    invalidData: "不正なデータです。",
    userNotFound: "ユーザーが見つかりません。",
    invalidToken: "不正なトークンです。",
    existDatabase: "データベースが既に存在します。",
    authorizationNotFound: "権限が見つかりません。",
    invalidCredential: "ユーザー名もしくはパスワードが間違っています。",
    deactiveUser: "有効でないユーザーです。",
    unauthorizedEscalation: "権限の昇格が許可されていません。",
    noFileUploaded: "ファイルがアップロードされていません。",
    workbookLocked: "ワークブックがロックされています。",
    unsupportedFileType: "対象のファイルタイプではありません。",
    missingRequirments: "対象のデータがありません。",
    missingDbId: "対象のデータがありません。",
    fileProcessing: "ファイルの処理中です。",
    applicationClear: "申請がクリアされました。",

    // Opt api
    optAD: "OPT AD",
    optApiError: "OPT エラー",
    optApiSuccess: "OPT 成功"
};

const lang = new LocalizedStrings({ en: defaultEn, ja: defaultJa });

export { lang };
